import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {HttpService} from '../../../services/http.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-cell-editor-related-parts',
  templateUrl: './cell-editor-related-parts.component.html',
  styleUrls: ['./cell-editor-related-parts.component.scss']
})
export class CellEditorRelatedPartsComponent implements ICellEditorAngularComp, OnInit, OnDestroy {
  // @ts-ignore
  @ViewChild('productInput') productInput: ElementRef<HTMLInputElement>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  productCtrl = new FormControl('');
  private params: any;
  public filteredOptions: any;
  filteredProducts: Observable<any[]> | undefined;
  public products: any[] = [];
  private saved: boolean = false;
  public skuInput: string = '';
  currentFilter: string = 'Equals';
  @ViewChild('skuSearch') searchElement: ElementRef | undefined;

  constructor(
    private httpService: HttpService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (!this.saved) {
      this.products = this.params.data.related_parts.slice();
      this.httpService.post(environment.API_PATH + '/product/stage/edit/stop', {}).subscribe((res: any) => {});
    }
  }

  checkExist(product_id: string): boolean {
    return this.products.find((x: any) => x.product_id === product_id);
  }

  changeFilterType(type: string): void {
    this.currentFilter = type;
    this.onChange(null);
    setTimeout(() => {
      // @ts-ignore
      this.searchElement.nativeElement.focus();
    }, 300);
  }

  agInit(params: any): void {
    this.params = params;

    if (this.params.data.related_parts.length) {
      this.products = this.params.data.related_parts.slice();
    }
  }

  getValue(): any {
    return this.products;
  }

  onChange($event: any) {
    this.filteredOptions = this.httpService.post(environment.API_PATH + '/product/stage/search', {
      // sku: $event.target.value,
      sku: this.searchElement?.nativeElement.value,
      type: this.currentFilter
    });
    // console.log('++__++', this.searchElement.nativeElement.value);
    // console.log('onChange', $event.target.value);
  }

  save() {
    this.saved = true;
    this.httpService.post(environment.API_PATH + '/product/stage/edit/stop', {}).subscribe((res: any) => {});
    this.params.stopEditing();
  }

  cancel() {
    this.products = this.params.data.related_parts.slice();
    console.log('this.params.data.related_parts;', this.products);
    this.params.stopEditing();
  }

  displayFn = (data: any) => {
    console.log('displayFn 🔴', data);
    this.products.push(data);
    return '';
  }

  remove(product_id: string): void {
    const index = this.products.indexOf(product_id);

    if (index >= 0) {
      this.products.splice(index, 1);
    }
  }

}
